import React from "react";
import PhysicalBanner from "../physicalrecords/PhysicalBanner";
import PhysicalClientLogo from "../physicalrecords/PhysicalClientLogo";
import PhysicalTool from "../physicalrecords/PhysicalTool";
import AiDocs from "./AiDocs";
import AiInsights from "./AiInsights";
import PhysicalGrowth from "../physicalrecords/PhysicalGrowth";
import PhysicalAdopt from "../physicalrecords/PhysicalAdopt";
import PhysicalFaq from "../physicalrecords/PhysicalFaq";
import PhysicalSecurity from "../physicalrecords/PhysicalSecurity";
import PhysicalDocs from "../physicalrecords/PhysicalDocs";
import PhysicalStorage from "../physicalrecords/PhysicalStorage";
import AiIndex from "./AiIndex";



const physicalData = {
  img: "/assets/images/ai-extraction-banner-bg.webp",
  head: "Cognitive Document Processing & AI Extraction",
  btn: "Contact Us",
  slug: "/contact"
};

const securityData = {
  head: "Intelligent Document Processing for Modern Workflows",
  desc: `<p>Transform how your organization handles documents. Capture critical data instantly, convert unstructured content into usable insights, accelerate operations with high accuracy and control.</p>`,
  boxes: [
    {
      img: "/assets/images/ai-extraction-tool-img-1.webp",
      label: "Vision-AI & Multi-Engine OCR"
    },
    {
      img: "/assets/images/ai-extraction-tool-img-2.webp",
      label: "Cognitive Data Extraction"
    },
    {
      img: "/assets/images/ai-extraction-tool-img-3.webp",
      label: "Full-Text Smart Search"
    },
    {
      img: "/assets/images/ai-extraction-tool-img-4.webp",
      label: "Deep-Content Analytics"
    },
    {
      img: "/assets/images/ai-extraction-tool-img-5.webp",
      label: "Intelligent Document Indexing"
    },
    {
      img: "/assets/images/ai-extraction-tool-img-6.webp",
      label: "Workflow Automation"
    },
    {
      img: "/assets/images/ai-extraction-tool-img-7.webp",
      label: "Automated Compliance Guardrails"
    },
    {
      img: "/assets/images/ai-extraction-tool-img-8.webp",
      label: "Audit Trail & Integrity Analytics"
    },

  ]
}

const accordData = {
  head: "Cognitive Data Extraction and Processing Engine",
  desc: "Unlock the full value of your documents with AI-powered extraction and intelligent processing.",
  boxes: [
    {
      head: "Smart Field Identification",
      para: 'Automatically detect and extract key data points from complex documents such as invoices, contracts, forms, reports. Reduce manual effort and improve accuracy.',
      img: "/assets/images/ai-extraction-docs-img-1.webp",
    },
    {
      head: "Semantic Data Understanding",
      para: 'Go beyond basic extraction. AI understands document context, relationships, meaning to ensure data is structured correctly and ready for use.',
      img: "/assets/images/ai-extraction-docs-img-2.webp",
    },
    {
      head: "High-Volume Document Handling",
      para: 'Process large volumes of documents efficiently without compromising speed or accuracy. Scale operations without increasing manual workload.',
      img: "/assets/images/ai-extraction-docs-img-3.webp",
    },
    {
      head: "Adaptive Learning Models",
      para: 'AI models continuously improve by learning from document patterns and corrections, delivering better accuracy over time.',
      img: "/assets/images/ai-extraction-docs-img-4.webp",
    },
  ]
}

const countData = {
  title: "Precision Data with Minimal Effort",
  para: "Turn static documents into dynamic, usable data that powers your workflows.",
  btn: "Unlock Your savings",
  stats: [
    {
      number: "99",
      suffix: "%",
      desc: "Extraction Accuracy"
    },
    {
      number: "85",
      suffix: "%",
      desc: " faster document processing"
    },
    {
      number: "60",
      suffix: "%",
      desc: " reduce operational costs"
    },
  ]
}

const storageData = {
  head: "Unified Document Management Platform",
  desc: `<p>Manage, process, <b>secure documents</b> from a single, intelligent interface.</p>`,
  boxes: [
    {
      img: "/assets/images/ai-extraction-storage-icon-1.webp",
      label: "AI-Powered Document Organization"
    },

    {
      img: "/assets/images/ai-extraction-storage-icon-2.webp",
      label: "Automated Document Preservation"
    },

    {
      img: "/assets/images/ai-extraction-storage-icon-3.webp",
      label: "Secure Document Protection"
    },

    {
      img: "/assets/images/ai-extraction-storage-icon-4.webp",
      label: "Multi-Source Integration"
    },

    {
      img: "/assets/images/ai-extraction-storage-icon-5.webp",
      label: "Blockchain-Secured Document Protection"
    },

    {
      img: "/assets/images/ai-extraction-storage-icon-6.webp",
      label: "User-Friendly Interface"
    },
  ]

}

const growthData = {
  head: "95% of customers say Dox and Box’s AI-powered document processing improves efficiency and supports business growth.",
  btn: "Book A Consultation",
  newClass: "ai-growth-bg"
}

const adoptData = {
  firstimg: "assets/images/physical-adopt-blur.webp",
  secondimg: "/assets/images/physical-adopt-img1.webp",
  thirdimg: "/assets/images/physical-adopt-img2.webp",
  name: "Ritesh Verma",
  position: "General Manager",
  desc: "Dox and Box streamlined our document workflows and eliminated manual bottlenecks. The system is secure, reliable, easy for teams to adopt. We’ve seen faster turnaround times and better compliance tracking, improving operational efficiency while reducing costs."
}

const faqData = {
  image:"/assets/images/physical-faq-img.webp",
  faqs:[
    {
      question:"What types of documents can your AI process?",
      answer:"Our AI can process a wide range of documents, including invoices, contracts, purchase orders, forms, bank statements, HR records, more. It is designed to handle both structured and unstructured formats across industries."
    },
    {
      question:"How accurate is the data extraction?",
      answer:"Our system delivers up to 99% extraction accuracy, depending on document quality and format. The AI continuously improves through adaptive learning, ensuring higher accuracy over time."
    },
    {
      question:" Does the system support high-volume document processing?",
      answer:"Yes. The platform is built to handle large volumes of documents efficiently. It scales with your business needs without requiring additional manual effort or resources."
    },
    {
      question:"Can the extracted data integrate with our existing systems?",
      answer:"Absolutely. Extracted data can be seamlessly integrated with your ERP, CRM, accounting software, or other business systems to automate workflows and improve data accessibility."
    },
    {
      question:"How secure is the document processing and extracted data?",
      answer:"We implement strong security measures, including encryption, access controls, audit trails to ensure your documents and data remain protected at every stage of processing."
    },
  ]
}

export default function AiExtraction() {
  return (
    <>
      <PhysicalBanner data={physicalData} />
      <PhysicalSecurity data={securityData} />
      <div className="ai-extraction-docs">
        <PhysicalDocs data={accordData} />
      </div>
      <div className="ai-extraction-tool">
        <PhysicalTool countData={countData} />
      </div>
      <AiInsights />
      <PhysicalClientLogo />
      <PhysicalGrowth data={growthData} noMargin={true} />
      <PhysicalStorage data={storageData} />
      <AiIndex />
      <PhysicalAdopt data={adoptData} />
      <PhysicalFaq data={faqData}/>
    </>
  )
}